import { BaseController } from '../../base/controller';

import { map } from 'lodash';

import template from './faq.modal.html';

class FaqController extends BaseController {
  constructor(faqService, $sce, freshdeskFaqsService, controllerService) {
    'ngInject';
    super({ faqService, $sce, freshdeskFaqsService, controllerService });
  }

  $onInit() {
    this.loading = true;
    this.freshdeskFaqsService.getFaqs(this.freshdeskFaqs).then((result) => {
      this.setFaqs(result.faqs);
      this.loading = false;
    });
    this.categories = [];
  }

  get freshdeskFaqs() {
    return this.config.ui.freshdeskFaqs;
  }

  get selectedCategory() {
    return this.categories[this.selectedCategoryIndex];
  }

  setFaqs(faqs) {
    if (!faqs) {
      this.error('COMPONENTS.FAQS.LOADING_ERROR');
      return;
    }

    // push all categories in one, since we can have multiple categories i.e. KWS, KWS Fiducia...
    let allCategories = [];

    map(faqs.folders, (folder) => {
      allCategories.push(folder);
    });

    this.selectedCategoryIndex = 0;

    this.categories = allCategories.map((category, index) => {
      category.index = index;
      return category;
    });
  }

  selectCategory(category) {
    this.selectedCategoryIndex = category.index;
  }

  isCategorySelected(category) {
    return this.selectedCategoryIndex === category.index;
  }

  getCategoryByIndex(index) {
    return this.categories.filter((category) => category.index === index)[0];
  }

  resetSearch() {
    this.search = '';
    this.searchChanged();
  }

  searchChanged() {
    let searchedCategories = null;

    if (this.search) {
      searchedCategories = [this.getFiltered(angular.copy(this.categories))];
    }
    this.setSearchedCategories(searchedCategories);
  }

  setSearchedCategories(categories) {
    this.searchCategories = categories;
  }

  toggle(e, $event) {
    $event.stopPropagation();
    e.open = !e.open;
  }

  getFiltered(array) {
    let filtered = { articles: [] };

    map(array, (category) => {
      map(category.articles, (article) => {
        if (this.containsSearch(article)) {
          filtered.articles.push(article);
        }
      });
    });
    return filtered;
  }

  containsSearch(a) {
    let titleContains =
      a.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    let descContains =
      a.description.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
    return titleContains || descContains;
  }

  trustAsHtml(content = '') {
    return this.$sce.trustAsHtml(
      content.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, ''),
    ); //.replace(/<[^\/>][^>]*><\/[^>]+>/gim, ''));
  }

  close() {
    this.faqService.closeModal();
  }
}

export default {
  restrict: 'E',
  bindings: {},
  template,
  controllerAs: 'vm',
  controller: FaqController,
};
